export default __webpack_public_path__ + "static/media/provesional_restoration_upper_21_4@2x.e0480580.png";